const systemIds = {
  mitStudieForside: 4,
  mitStudieStudiekort: 5,
  mitStudieStudieoverblik: 6,
  mitStudieStudienævn: 7,
  mitStudieKortOverAu: 8,
  mitStudieVelkomstside: 9,
};

export default systemIds;
